import { PageVisibleState } from '@atlassian/ufo-experimental/types';
export const pageVisibleState = data => {
  var _data$pageVisibleStat;
  return {
    'experience:pageVisible': (_data$pageVisibleStat = data.pageVisibleState) !== null && _data$pageVisibleStat !== void 0 ? _data$pageVisibleStat : document.hidden ? PageVisibleState.HIDDEN : PageVisibleState.VISIBLE
  };
};